module.exports = __webpack_public_path__ + "fonts/b8ae8323d707111008ddac27d41fda9a.svg";